// extracted by mini-css-extract-plugin
export var shareButton = "share-module--shareButton--d8243";
export var shareParent = "share-module--shareParent--43481";